import React, { Suspense } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { Images } from "./../assets/common";
import { Typography } from "@mui/material";
import Signup from "./Signup";
import WaitList from "./WaitList";
import AppContainer from "./AppContainer";
import ServerDown from "./ServerDown";
import AddTokens from "./AddTokens";
import TermsAndCondition from "./TermsAndCondition";
import PrivacyPolicy from "./PrivacyPolicy";
import {
  getUserDetail,
  isLoggedInUser,
  isWhiteListed,
} from "../constants/function";
import LiveVideoStreaming from "./Streaming";
//route guard
function PrivateRoute({ component: Component, path, appProps, ...rest }) {
  const unauthorisedUrl = ["/", "Signup"];
  const userData = getUserDetail();
  return (
    <Route
      {...rest}
      render={(props) => {
        if (
          isLoggedInUser() &&
          unauthorisedUrl.includes(props.location.pathname) &&
          isWhiteListed()
        ) {
          return (
            <Redirect
              to={{
                pathname: `/app/Home`,
              }}
            />
          );
        } else if (
          isLoggedInUser() &&
          isWhiteListed() &&
          !userData["birthYear"]
        ) {
          return (
            <Redirect
              to={{
                pathname: "/",
              }}
            />
          );
        } else if (isLoggedInUser() && isWhiteListed()) {
          return <Component {...props} {...appProps} />;
        } else if (isLoggedInUser() && !isWhiteListed()) {
          return (
            <Redirect
              to={{
                pathname: "/WaitList",
              }}
            />
          );
        } else {
          return (
            <Redirect
              to={{
                pathname: "/",
              }}
            />
          );
        }
      }}
    />
  );
}
function RouterOutlet(props) {
  return (
    <Switch
      fallback={
        <div style={{ position: "relative", height: "100vh" }}>
          <img style={{ width: "100%" }} src={Images.splash} alt="SIKI" />
          <Typography
            sx={{
              fontFamily: '"Anton", sans-serif',
              fontSize: "45px",
              position: "absolute",
              top: "0",
              bottom: "0",
              left: "0",
              right: "0",
              margin: "auto",
              width: "100px",
              height: "100px",
            }}
          >
            SIKI
          </Typography>
        </div>
      }
    >
      <Route exact path="/" render={(props) => <Signup {...props} />} />
      <Route
        exact
        path="/WaitList"
        render={(props) => <WaitList {...props} />}
      />
      <Route
        exact
        path="/TermsAndCondition"
        render={(props) => <TermsAndCondition {...props} />}
      />
      <Route
        exact
        path="/PrivacyPolicy"
        render={(props) => <PrivacyPolicy {...props} />}
      />
      <Route path="/maintenance" component={ServerDown} />
      <Route path="/signup" component={Signup} />
      <Route path="/LiveVideoStreaming" component={LiveVideoStreaming} />
      <PrivateRoute path="/app" component={AppContainer} />
      <PrivateRoute exact path="/add-siki-token" component={AddTokens} />
    </Switch>
  );
}

export default RouterOutlet;
